import * as React from 'react';
import { Str } from '../../localization/translationKeys';
import ModalHeader from '../../layout/modal/ModalHeader';
import Modal from '../../layout/modal/Modal';
import Msg from '../../localization/Msg';
import { btnStyle } from '../../forms/styles/button';
import { COLORS } from '../../globalStyle/colors';
import LocalBtn from '../../localization/LocalBtn';
import LocalDiv from '../../localization/LocalDiv';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { css } from '@emotion/core';
import Spacer from '../../layout/Spacer';
import { onPhone, onMobileMedium } from '../../globalStyle/mediaQueries';
import { useBrowser } from '../../language/useBrowser';


const styles = {
  modal:        css`
    min-height: 300px;
    min-width: 300px;
    max-width: 560px;
    margin: 40px;
    ${onPhone} {
      margin: 0;
    }
  `,
  content:      css`
    flex-grow: 1;
    margin: 0 20px 20px;
  `,
  msgContainer: css`
    margin: auto 90px;
    flex-grow: 1;
    justify-content: center;
    ${onMobileMedium} {
      margin: auto 40px;
    }
    ${onPhone} {
      margin-bottom: 60px;
    }
  `,
  msg:          css`
    font-weight: bold;
    font-size: 18px;
    line-height: 1.5;
  `,
  btnRow:       css`
    width: 100%;
    flex-grow: 0;
    margin-top: auto;
    justify-content: center;
  `,
  btn:          css`
    min-height: 35px;
    min-width: 132px;
  `,
};

type Props = {
  className?: string;
  onClickYes: () => void;
  onDismiss: () => void;
};


/**
 * ReassessmentModal: a component that
 *
 * PureComponent: true
 * Redux Connected:
 */
const ReassessmentModal: React.FC<Props> = props => {
  const { onIe } = useBrowser();

  return (
    <Modal css={[FLEX_COLUMN, styles.modal, props.className]} onDismiss={props.onDismiss}>
      <ModalHeader onDismiss={props.onDismiss} />
      <LocalDiv css={[FLEX_COLUMN, styles.content]}>
        <div css={[FLEX_COLUMN, styles.msgContainer, onIe ? css`padding: 65px 0;` : undefined]}>
          <Msg css={styles.msg} str={Str.ReassessmentAreYouSure} />
        </div>
        <LocalDiv css={[FLEX_ROW, styles.btnRow]}>
          <div css={css`flex-basis: 100%;`} />
          <LocalBtn
            str={Str.Yes}
            css={[btnStyle.transparent(COLORS.BLUE), styles.btn]}
            onClick={props.onClickYes}
          />
          <Spacer sizePx={10} />
          <LocalBtn
            str={Str.No}
            css={[btnStyle.primary(COLORS.BLUE), styles.btn]}
            onClick={props.onDismiss}
          />
        </LocalDiv>
      </LocalDiv>
    </Modal>
  )
};

export default ReassessmentModal;
